import { SEND_DIPLOMA_SUCCESS } from './constants';

let sendDiplomaState = {
    error: false,
    status:'message sended'
};

/**
 *
 * @param state
 * @param action
 * @returns {{error: boolean, status: string}}
 */
const emailSender = (state = sendDiplomaState, action) => {
    switch (action.type) {
        case SEND_DIPLOMA_SUCCESS : {
            sendDiplomaState = {...action.result};
            return sendDiplomaState;
        }
        default:
            return state;
    }
};

export { emailSender };